import { Injectable, Injector } from "@angular/core";
import { BaseApiService } from "@carm/_core/baseapi.service";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "src/environments/environment";
import { IDisableLogin } from "../models/disable-login.model";
import { ILogoImage } from "../models/logo-image.model";

@Injectable()
export class DeploymentService extends BaseApiService {
  constructor(protected injector: Injector) {
    super(injector);
  }

  public shouldDisableLogin(): Observable<IDisableLogin> {
    const endpoint = `${environment.baseApiUrls}/deployment/disable-login`;
    return this.httpGet<IDisableLogin>(endpoint);
  }

  public getPartnersLogos(language: string): ILogoImage[] {
      return [
        { logo: `af-${language}.png`, text: 'af' },
        { logo: `atb-${language}.png`, text: 'atb' },
        { logo: `bmo-${language}.png`, text: 'bmo' },
        { logo: `ca-${language}.png`, text: '' },
        { logo: `cibc-${language}.png`, text: 'cibc' },
        { logo: `cc-${language}.png`, text: 'caisses' },
        { logo: `ccu-${language}.png`, text: 'conexus' },
        { logo: `dj-${language}.png`, text: 'desjardins' },
        { logo: `lcu-${language}.png`, text: '' },
        { logo: `nb-${language}.png`, text: 'national' },
        { logo: `rbc-${language}.png`, text: 'rbc' },
        { logo: `sb-${language}.png`, text: 'scotiabank' },
        { logo: `scu-${language}.png`, text: 'servus' },
        { logo: `sf-${language}.png`, text: '' },
        { logo: `tfb-${language}.png`, text: 'tangerine' },
        { logo: `td-${language}.png`, text: 'td' },
        { logo: `uni-${language}.png`, text: 'uni' },
        { logo: `vc-${language}.png`, text: 'vancity' },
      ];
  }
}